/* Todo, discuss, I think it would be beneficial if we had the theme available here */
import baseImageDefaults from '../BaseImage/BaseImage.defaults'

export default {
		text: 'John Doe',
		subtext: 'Marketing Expert',
		image: baseImageDefaults,
		textColor: 'var(--text-color)',
		subTextColor: 'var(--text-color)'
}